module.exports = __webpack_public_path__ + "static/media/cadena_hidrogeno.1a042a08.png";